export const APP_SUBJECTS = [
    { name: 'Home', subject: 'Home' },
    { name: 'Bovinos', subject: 'Bovine' },
    { name: 'Caixa', subject: 'CashFlow' },
    { name: 'Fazendas', subject: 'Farm' },
    { name: 'Lote/Piquetes', subject: 'FarmLot' },
    { name: 'Serviço', subject: 'Service' },
    { name: 'Proprietários', subject: 'Owner' },
    { name: 'Usuários', subject: 'User' },
    { name: 'Vendas', subject: 'Sale' },
];
